"use client";

import { useState, useTransition } from "react";
import { adjustUnitateCountValue, setUnitateCountValue } from "../actions";

export function CountsForm({ unitateId, count }: { unitateId: string; count: number }) {
  const [current, setCurrent] = useState(count);
  const [exact, setExact] = useState(String(count));
  const [error, setError] = useState<string | null>(null);
  const [pending, startTransition] = useTransition();

  function adjust(delta: number) {
    if (delta < 0 && current <= 0) return;
    setError(null);
    startTransition(async () => {
      try {
        const { count: next } = await adjustUnitateCountValue(unitateId, delta);
        setCurrent(next);
        setExact(String(next));
      } catch {
        setError("Nu s-a putut salva.");
      }
    });
  }

  function submitExact(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    const value = Number(exact);
    startTransition(async () => {
      try {
        await setUnitateCountValue(unitateId, value);
        setCurrent(value);
      } catch {
        setError("Valoare invalidă — introduceți un număr întreg, nenegativ.");
      }
    });
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <button
          type="button"
          disabled={pending || current <= 0}
          onClick={() => adjust(-1)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-slate-300 text-lg text-slate-600 hover:bg-slate-50 disabled:opacity-40"
          aria-label="Scade cu unu"
        >
          −
        </button>
        <span className="w-16 text-center text-2xl font-semibold text-slate-900">{current}</span>
        <button
          type="button"
          disabled={pending}
          onClick={() => adjust(1)}
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-slate-300 text-lg text-slate-600 hover:bg-slate-50 disabled:opacity-40"
          aria-label="Crește cu unu"
        >
          +
        </button>
        <span className="text-sm text-slate-500">exemplare</span>
      </div>

      <form onSubmit={submitExact} className="flex items-end gap-3">
        <div>
          <label className="mb-1 block text-sm font-medium text-slate-700">Corectează valoarea exactă</label>
          <input
            type="number"
            min={0}
            step={1}
            value={exact}
            onChange={(e) => setExact(e.target.value)}
            className="w-32 rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100"
          />
        </div>
        <button
          disabled={pending}
          className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-60"
        >
          Setează
        </button>
      </form>

      {error ? (
        <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>
      ) : null}
    </div>
  );
}
